<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Create an account
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="text-center">
              Once you create your account, you can log in using the provided email address and password.
            </p>
            <hr>
            <notifications />

            <form
              ref="registerForm"
              @submit.prevent="register"
            >
              <h1 class="text-center">
                Register for a free account
              </h1>

              <div class="form-group row">
                <label
                  for="name"
                  class="col-md-4 col-form-label text-md-right"
                >Name</label>

                <div class="col-md-6">
                  <input
                    id="name"
                    v-model="form.name"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                  >
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="email"
                  class="col-md-4 col-form-label text-md-right"
                >E-Mail Address</label>

                <div class="col-md-6">
                  <input
                    id="email"
                    v-model="form.email"
                    type="email"
                    class="form-control"
                    required
                  >
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="password"
                  class="col-md-4 col-form-label text-md-right"
                >Password</label>

                <div class="col-md-6">
                  <input
                    id="password"
                    v-model="form.password"
                    type="password"
                    class="form-control"
                    required
                  >
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="password-confirm"
                  class="col-md-4 col-form-label text-md-right"
                >Confirm Password</label>

                <div class="col-md-6">
                  <input
                    id="password-confirm"
                    v-model="form.password_confirmation"
                    type="password"
                    class="form-control"
                    required
                  >
                </div>
              </div>
              <div class="form-group row mb-0">
                <div class="col-md-6 offset-md-4">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg"
                  >
                    Register
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Auth from '../services/auth.js';
import Coupon from '../services/coupons.js';
import Plans from '../services/plans.js';

export default {
  data() {
    return {
      form: {}
    }
  },
  methods: {
    async register() {
      if (this.$refs.registerForm.checkValidity()) {

        try {

          this.$store.dispatch('notifications/clear');

          let res = await Auth.registerFree(this.form);

          this.$store.dispatch('user/login', {email: this.form.email, password: this.form.password}).then((res) => {
            this.$router.push(this.$route.query.redirect || {name: 'health-data'});
            this.$store.dispatch('notifications/setSuccess', 'Welcome to Food Fitness First©!');
          }).catch((err) => {
            this.$router.push({name: 'login'});
            this.$store.dispatch('notifications/setError', 'There was a problem logging you in.  Please try again.');
          })

        } catch (err) {
          window.scrollTo(0,0);
          this.$store.dispatch('notifications/setError', 'There was a problem registering');
          this.$store.dispatch('notifications/setErrorBag', err.response.data.errors || null);
        }

      } else {
        this.$refs.registerForm.reportValidity();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .error {
        color: red;
    }
    .card-input {
        padding-top: .6em;
    }
    .coupon-input {
        font-size: 1.1em;
    }
    .price-text {
        font-size: 2.8em;

        &-disabled {
            text-decoration: line-through;
            color: red;
            font-style: italic;
        }
    }
</style>
